import React from 'react'

import { Box } from '@chakra-ui/react'

import TextArea from 'src/components/widgets/TextArea/TextArea'
import VoiceTipRecorder from 'src/components/widgets/VoiceTipRecorder/VoiceTipRecorder'

import { TypeBuilderProps } from '../..'

const MAX_VOICE_TIP_LABEL_LENGTH = 50

const Builder: React.FC<Pick<TypeBuilderProps, 'voiceTipRecorderProps'>> = ({
  voiceTipRecorderProps,
}) => {
  return (
    <Box mt={4} w="full">
      <VoiceTipRecorder
        name="hasVoiceTip"
        mb={4}
        title="Audio"
        {...voiceTipRecorderProps}
      />
      <TextArea
        w="full"
        rows={1}
        name="title"
        placeholder="Label"
        maxLength={MAX_VOICE_TIP_LABEL_LENGTH}
        withCounter={true}
        countDown={true}
        hint="Optional"
        data-testid="voiceTipBuilder-label"
      />
    </Box>
  )
}

export default Builder
